/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Body_AddImageInProject } from '../models/Body_AddImageInProject';
import type { ProjectPost } from '../models/ProjectPost';
import type { ProjectPostResponse } from '../models/ProjectPostResponse';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class ProjectService {

    /**
     * Add new project
     * Add new project
     * @param requestBody
     * @returns ProjectPostResponse Successful Response
     * @throws ApiError
     */
    public static addNewProject(
        requestBody: ProjectPost,
    ): CancelablePromise<ProjectPostResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/project',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Return all project
     * Return all project
     * @returns ProjectPostResponse Successful Response
     * @throws ApiError
     */
    public static returnAllProject(): CancelablePromise<ProjectPostResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/project/all-project',
        });
    }

    /**
     * Add image in project
     * Add image in project
     * @param formData
     * @returns any Successful Response
     * @throws ApiError
     */
    public static addImageInProject(
        formData: Body_AddImageInProject,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/project/add-image',
            formData: formData,
            mediaType: 'multipart/form-data',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Update project
     * Update project
     * @param idProject
     * @param requestBody
     * @returns ProjectPostResponse Successful Response
     * @throws ApiError
     */
    public static updateProject(
        idProject: string,
        requestBody: ProjectPost,
    ): CancelablePromise<ProjectPostResponse> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/project/update-project',
            query: {
                'id_project': idProject,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Delete project
     * Delete project
     * @param idProject
     * @returns ProjectPostResponse Successful Response
     * @throws ApiError
     */
    public static deleteProject(
        idProject: string,
    ): CancelablePromise<ProjectPostResponse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/project/delete-project',
            query: {
                'id_project': idProject,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

}
